import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { AppDispatch, RootState } from "."
import { authApi } from "../api/auth-api"

interface AuthState {
    isAuth: boolean
}

const initialState: AuthState = {
    isAuth: false
}

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setIsAuthAction: (state, action: PayloadAction<boolean>) => {
            state.isAuth = action.payload
        }
    }
})

export const { setIsAuthAction } = authSlice.actions

export default authSlice.reducer

export const selectIsAuth = (state: RootState) => state.auth.isAuth

export const authThunk = {
    auth: () => async (dispatch: AppDispatch) => {
        const response = await authApi.auth()
        dispatch(setIsAuthAction(response))
    } 
}